/**
 * Routine の締めの確定の明細(2026-10-23・表示だけ)。中身は RoutineStatement(Routine の PDF と同じ形)。
 * Routine の PDF(原本)が届いていれば一緒に出す。「印刷・PDF 保存」で印刷ページ(/routine/print/:id)へ
 */
import { useNavigate } from 'react-router-dom';
import Modal from '@core/components/Modal';
import { useMasters } from '@core/masters/MastersProvider';
import AttachmentThumbs from '@core/expense/AttachmentThumbs';
import type { RoutineClosing } from '@core/lib/types';
import { STAGE_LABELS, monthLabel, shortDateTime, type GateState } from './routineClosing';
import RoutineStatement, { issuerFromCompanies } from './RoutineStatement';

const TONE: Record<GateState['tone'], string> = { ok: 'b-ok', plan: 'b-plan', pend: 'b-pend', warn: 'b-ng', none: '' };

export function GateStateBadge({ state }: { state: GateState }) {
  return <span className={`badge ${TONE[state.tone]}`}>{state.label}</span>;
}

/** Routine が送った PDF(原本)。まだ届かない間は何も出さない */
export function RoutineDocuments({ closing }: { closing: RoutineClosing }) {
  if (!closing.documents?.length) return null;
  return (
    <div style={{ marginTop: 14 }}>
      <p style={{ margin: '0 0 6px', fontWeight: 700 }}>Routine の PDF(原本)</p>
      <AttachmentThumbs files={closing.documents} />
    </div>
  );
}

export default function RoutineClosingDetailModal({ closing, state, onClose }: { closing: RoutineClosing; state: GateState; onClose: () => void }) {
  const navigate = useNavigate();
  const { companies } = useMasters();
  return (
    <Modal onClose={onClose} width={closing.detail.kind === 'billing' ? 'min(1240px, 96vw)' : 'min(860px, 94vw)'}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 6 }}>
        <h3 style={{ margin: 0 }}>
          {STAGE_LABELS[closing.stage]}: {closing.name}({monthLabel(closing.month)}分)
        </h3>
        <GateStateBadge state={state} />
        {closing.status === 'cancelled' && <span className="badge b-ng">Routine で取り消し</span>}
      </div>
      <p className="hint" style={{ margin: '0 0 12px' }}>
        Routine で確定: {shortDateTime(closing.confirmed_at)}
        {closing.confirmed_by_name ? `(${closing.confirmed_by_name})` : ''}・Gate に届いた日時: {shortDateTime(closing.received_at)}・Routine の確定 ID: {closing.source_id}
      </p>

      <RoutineStatement closing={closing} issuer={issuerFromCompanies(companies)} />
      <RoutineDocuments closing={closing} />

      <div className="modal-actions">
        <button className="btn-line" onClick={onClose}>
          閉じる
        </button>
        <button className="btn-line" onClick={() => navigate(`/routine/print/${closing.id}`)}>
          印刷・PDF 保存
        </button>
        {state.to && (
          <button className="btn-green" onClick={() => navigate(state.to!)}>
            {state.linkLabel}
          </button>
        )}
      </div>
    </Modal>
  );
}
